<template>
  <div class="relative py-1 px-1" :class="{ 'border-t border-n-weak': showBorder }">
    <div
      class="flex items-center cursor-pointer bg-n-solid-1 hover:bg-n-slate-3 transition-colors rounded-lg p-3" 
      @click="toggleDropdown"
    >
      <!-- Icon -->
      <div class="w-6 text-slate-500 dark:text-slate-400 text-center mr-3">
        <span :class="icon" />
      </div>

      <!-- Title and Value -->
      <div class="flex-grow">
        <div class="text-xs text-slate-500 dark:text-slate-400 mb-1">
          {{ label }}
        </div>
        <div class="text-sm font-medium text-slate-700 dark:text-slate-200">
          {{ selectedItem?.name || placeholder }}
        </div>
      </div>

      <!-- Chevron -->
      <div class="text-slate-500 dark:text-slate-400">
        <span class="i-lucide-chevron-down text-sm" />
      </div>
    </div>

    <!-- Dropdown -->
    <div
      v-if="showDropdown"
      v-on-clickaway="closeDropdown"
      class="dropdown-pane dropdown-pane--open absolute top-full left-4 right-4 mt-1 z-50"
    >
      <WootDropdownMenu class="mb-0">
        <WootDropdownItem 
          v-if="items && items.length > 0" 
          v-for="item in items" 
          :key="item.id"
        >
          <Button
            :label="item.name"
            ghost
            slate
            sm
            start
            :icon="icon"
            class="w-full"
            @click="selectItem(item)"
          />
        </WootDropdownItem>
        <WootDropdownItem v-else>
          <div class="px-3 py-2 text-sm text-slate-500 dark:text-slate-400">
            {{ emptyMessage }}
          </div>
        </WootDropdownItem>
      </WootDropdownMenu>
    </div>
  </div>
</template>

<script>
import Button from 'dashboard/components-next/button/Button.vue';
import WootDropdownItem from 'shared/components/ui/dropdown/DropdownItem.vue';
import WootDropdownMenu from 'shared/components/ui/dropdown/DropdownMenu.vue';

export default {
  name: 'ContactInfoDropdown',
  components: {
    Button,
    WootDropdownItem,
    WootDropdownMenu,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    selectedItem: {
      type: Object,
      default: null,
    },
    placeholder: {
      type: String,
      default: 'Nenhum',
    },
    emptyMessage: {
      type: String,
      default: 'Nenhum item disponível',
    },
    showBorder: {
      type: Boolean,
      default: true,
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'select'],
  computed: {
    showDropdown: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    closeDropdown() {
      this.showDropdown = false;
    },
    selectItem(item) {
      this.$emit('select', item);
      this.closeDropdown();
    },
  },
};
</script>

<style scoped>
.dropdown-pane {
  .dropdown-menu__item {
    @apply mb-0;
  }
}
</style>